<div class="launchpad-container" *ngIf="config">
    <!-- Header -->
    <div class="launchpad-header">
        <div class="header-content">
            <div class="module-info">
                <i [class]="config.moduleIcon + ' header-icon'"></i>
                <div>
                    <h1>{{config.moduleName}}</h1>
                    <p class="subtitle">Willkommen im {{config.moduleName}} Launchpad</p>
                </div>
            </div>
            <div class="header-actions">
                <button pButton
                        *ngIf="config.aiChatEnabled"
                        icon="pi pi-comment"
                        label="AI Hilfe"
                        class="p-button-outlined"
                        (click)="onOpenAiChat()">
                </button>
            </div>
        </div>
    </div>

    <!-- Loading -->
    <div *ngIf="isLoading" class="loading-container">
        <i class="pi pi-spin pi-spinner" style="font-size: 2rem;"></i>
        <p>Launchpad wird geladen...</p>
    </div>

    <!-- Sections -->
    <div *ngIf="!isLoading" class="launchpad-sections">

        <!-- Quick Actions Section -->
        <div *ngFor="let section of sections" class="launchpad-section">
            <ng-container [ngSwitch]="section.type">

                <!-- Quick Actions -->
                <ng-container *ngSwitchCase="'quick-actions'">
                    <h2 class="section-title">{{section.title}}</h2>
                    <div class="quick-actions-grid">
                        <div *ngFor="let action of quickActions"
                             class="quick-action-card"
                             [class.disabled]="action.disabled"
                             (click)="!action.disabled && onQuickActionClick(action)">
                            <div class="action-icon" [style.background-color]="action.color || 'var(--primary-color)'">
                                <i [class]="action.icon"></i>
                            </div>
                            <div class="action-content">
                                <span class="action-label">{{action.label}}</span>
                                <span class="action-description">{{action.description}}</span>
                            </div>
                            <span *ngIf="action.badge" class="action-badge">{{action.badge}}</span>
                        </div>
                    </div>
                </ng-container>

                <!-- Guides / Tours -->
                <ng-container *ngSwitchCase="'guides'">
                    <h2 class="section-title">{{section.title}}</h2>
                    <div class="guides-list" *ngIf="availableTours.length > 0">
                        <div *ngFor="let tour of availableTours" class="guide-item" (click)="onStartTour(tour)">
                            <i class="pi pi-play-circle guide-icon"></i>
                            <div class="guide-content">
                                <span class="guide-title">{{tour.title}}</span>
                                <span class="guide-description">{{tour.description}}</span>
                            </div>
                            <i class="pi pi-chevron-right"></i>
                        </div>
                    </div>
                    <div class="empty-state" *ngIf="availableTours.length === 0">
                        <p>Alle Guides wurden abgeschlossen.</p>
                    </div>
                </ng-container>

                <!-- Documentation -->
                <ng-container *ngSwitchCase="'documentation'">
                    <h2 class="section-title">{{section.title}}</h2>
                    <div class="documentation-grid">
                        <div class="doc-column">
                            <h3>Beliebte Artikel</h3>
                            <div *ngFor="let article of popularArticles" class="article-item" (click)="onArticleClick(article)">
                                <i class="pi pi-file-edit"></i>
                                <div class="article-info">
                                    <span class="article-title">{{article.title}}</span>
                                    <span class="article-meta">{{article.viewCount}} Aufrufe</span>
                                </div>
                            </div>
                        </div>
                        <div class="doc-column">
                            <h3>Neueste Artikel</h3>
                            <div *ngFor="let article of recentArticles" class="article-item" (click)="onArticleClick(article)">
                                <i class="pi pi-file-edit"></i>
                                <div class="article-info">
                                    <span class="article-title">{{article.title}}</span>
                                    <span class="article-meta">{{article.lastModifiedDate | date:'dd.MM.yyyy'}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <!-- Statistics (placeholder - module-specific) -->
                <ng-container *ngSwitchCase="'statistics'">
                    <h2 class="section-title">{{section.title}}</h2>
                    <ng-content select="[launchpad-statistics]"></ng-content>
                </ng-container>

                <!-- Recent Activity (placeholder - module-specific) -->
                <ng-container *ngSwitchCase="'recent-activity'">
                    <h2 class="section-title">{{section.title}}</h2>
                    <ng-content select="[launchpad-recent-activity]"></ng-content>
                </ng-container>

                <!-- Custom (placeholder - module-specific) -->
                <ng-container *ngSwitchCase="'custom'">
                    <h2 class="section-title">{{section.title}}</h2>
                    <ng-content select="[launchpad-custom]"></ng-content>
                </ng-container>

            </ng-container>
        </div>
    </div>
</div>

<!-- No config state -->
<div *ngIf="!config && !isLoading" class="no-config-state">
    <i class="pi pi-info-circle" style="font-size: 3rem; color: var(--surface-400);"></i>
    <h2>Kein Launchpad konfiguriert</h2>
    <p>Fuer dieses Modul wurde noch kein Launchpad eingerichtet.</p>
</div>
